import "../../assets/index25.css";
import { jsxs as g, Fragment as u, jsx as t } from "react/jsx-runtime";
import { I as p } from "../../chunks/index.3a885b6a.js";
import { g as N } from "../../chunks/generate-random-id.f7e64105.js";
import { m as O } from "../../chunks/make-refs.cb0b9b76.js";
import { forwardRef as B, useState as C, useEffect as R } from "react";
import { c as $ } from "../../chunks/index.80e735c1.js";
const w = "_button_1dvj5_1", D = "_primary_1dvj5_29", E = "_secondary_1dvj5_43", F = "_dark_1dvj5_57", L = "_outline_1dvj5_72", S = "_ghost_1dvj5_87", T = "_leading_1dvj5_100", q = "_large_1dvj5_104", A = "_medium_1dvj5_113", G = "_small_1dvj5_122", H = "_loading_1dvj5_131", J = "_loadingIcon_1dvj5_131", K = "_spin_1dvj5_1", M = "_srOnly_1dvj5_135", n = {
  button: w,
  primary: D,
  secondary: E,
  dark: F,
  outline: L,
  ghost: S,
  leading: T,
  large: q,
  medium: A,
  small: G,
  loading: H,
  loadingIcon: J,
  spin: K,
  srOnly: M
}, P = ({
  className: e,
  contrast: a,
  icon: i,
  iconPosition: o,
  isLoading: c,
  size: d,
  variant: s
}) => $(n.button, e, {
  [n.loading]: c,
  [n[a]]: !!a && a !== "light",
  [n[o]]: !!i && o !== "trailing",
  [n[d]]: !!d,
  [n[s]]: !!s
}), nn = B(
  ({
    className: e,
    contrast: a = "light",
    disabled: i,
    icon: o,
    iconPosition: c = "trailing",
    isDecorative: d = !1,
    isLoading: s = !1,
    loadingA11yLabel: j,
    label: y,
    size: f = "large",
    variant: b = "primary",
    ...v
  }, h) => {
    const [l, I] = C(s), { $el: k } = O(h, ["$el"]), m = N("button-loading");
    R(() => {
      I(s);
    }, [s]);
    const r = {
      className: P({
        className: e,
        contrast: a,
        icon: o,
        iconPosition: c,
        isLoading: l,
        size: f,
        variant: b
      }),
      ref: k,
      ...v
    }, x = j || "Loading", _ = l ? /* @__PURE__ */ g(u, { children: [
      /* @__PURE__ */ t(p, { icon: "24/symbol/status-loading", className: n.loadingIcon }),
      /* @__PURE__ */ t("span", { id: m, className: n.srOnly, children: x })
    ] }) : /* @__PURE__ */ g(u, { children: [
      y,
      o && /* @__PURE__ */ t(p, { icon: o })
    ] });
    return d ? /* @__PURE__ */ t("span", { ...r, children: _ }) : r.href ? /* @__PURE__ */ t("a", { ...r, children: _ }) : /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        ...r,
        "aria-busy": l,
        "aria-describedby": l ? m : void 0,
        disabled: l || i,
        children: _
      }
    );
  }
);
export {
  nn as Button
};
//# sourceMappingURL=index.js.map
